import React from "react";
import styled from "@emotion/styled";

import { Badge, Grid, Avatar, Typography } from "@mui/material";
import { green } from "@mui/material/colors";

import { useAuth } from "@auth/AuthContext";
import { fontSizes } from "../../design-system/tokens";

const Footer = styled.div`
  background-color: ${(props) =>
    props.theme.sidebar.footer.background} !important;
  padding: ${(props) => props.theme.spacing(2.75)}
    ${(props) => props.theme.spacing(2)};
  border-right: 1px solid ${(props) => props.theme.palette.divider};
`;

const FooterText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
`;

const FooterSubText = styled(Typography)`
  color: ${(props) => props.theme.sidebar.footer.color};
  font-size: ${fontSizes.xs};
  display: block;
  padding: 1px;
`;

const FooterBadge = styled(Badge)`
  margin-right: ${(props) => props.theme.spacing(1)};
  span {
    background-color: ${() => green[400]};
    border: 2px solid ${(props) => props.theme.sidebar.footer.background};
    height: 12px;
    width: 12px;
    border-radius: 50%;
  }
`;

const SidebarFooter = ({ ...rest }) => {
  const { user, tenantInfo } = useAuth();

  return (
    <Footer {...rest}>
      <Grid container spacing={2}>
        <Grid item>
          <FooterBadge
            overlap="circular"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            variant="dot"
          >
            {!!user && <Avatar alt={user.name} src={user.avatar} />}
          </FooterBadge>
        </Grid>
        <Grid item>
          {!!user && (
            <>
              <FooterText variant="body2">{user.name}</FooterText>
              <FooterText variant="body2">
                Tenant: {tenantInfo?.name}
              </FooterText>
            </>
          )}
        </Grid>
      </Grid>
    </Footer>
  );
};

export default SidebarFooter;
